.hc{gap:0.25rem;}